import axios from "axios";

import ls from "@/services/local-storage";

import axiosErrorHandler from "@/utils/axios-error-handler";

export const DAO_SESHAT = () => {
  const dao = axios.create({
    baseURL: process.env.VUE_APP_API_SESHAT_URL,
    withCredentials: false,
    headers: {
      Authorization: "Bearer " + ls.getToken()
    }
  });
  dao.interceptors.response.use(
    response => response,
    error => axiosErrorHandler(error)
  );
  return dao;
};

export const ContentExtractionApi = () => {
  return axios.create({
    baseURL: process.env.VUE_APP_API_EXTRACT_CONTENT_URL,
    withCredentials: false
  });
};
